import React, { useState,useCallback } from 'react';
import { Button, Modal as ModalStrap, Container, ModalBody, ModalFooter } from 'reactstrap';
import ConfirmationModal from './ConfirmationModal';

const Modal = ({ children, open, actions, className, onClose, title, heightOffset, isPassengerModal }) => {
    const [showConfirmationModal, setShowConfirmationModal] = useState(false)

    const onCloseWindowClick =useCallback(() => {
       if (!isPassengerModal)
            onClose()
        else {
            setShowConfirmationModal(!showConfirmationModal)
        }
      },
      [showConfirmationModal,isPassengerModal,onClose]
    )
     
    return (
        <React.Fragment>
            <ConfirmationModal key={showConfirmationModal} showModal={showConfirmationModal} onClose={onClose} onCancelHandle={onCloseWindowClick} />
            <ModalStrap toggle={onClose} isOpen={open ? true : false} className={className} size="xl" style={{ paddingTop: heightOffset }} scrollable={true} backdrop={isPassengerModal?"static":true}>
                <Container style={{ backgroundColor: 'lightblue' }}>{title}</Container>
                <ModalBody>
                    {children}
                </ModalBody>
                <ModalFooter>
                    {actions}
                    <Button color="secondary" onClick={onCloseWindowClick}>Close Window</Button>
                </ModalFooter>
            </ModalStrap>
        </React.Fragment>
    );

};

export default Modal;

